import { Recipe } from '../models/Recipe';

/** Move ingredient one position up in the list. */
export const shiftIngredientUp = (recipe: Recipe, index: number): Recipe => {
  const ingredients = [...recipe.ingredients];
  const [removed] = ingredients.splice(index, 1);
  ingredients.splice(Math.max(index - 1, 0), 0, removed);
  return { ...recipe, ingredients };
};

/** Move ingredient one position down in the list. */
export const shiftIngredientDown = (recipe: Recipe, index: number): Recipe => {
  const ingredients = [...recipe.ingredients];
  const [removed] = ingredients.splice(index, 1);
  ingredients.splice(Math.min(index + 1, ingredients.length), 0, removed);
  return { ...recipe, ingredients };
};

/** Remove ingredient at a given index. */
export const removeIngredient = (recipe: Recipe, index: number): Recipe => ({
  ...recipe,
  ingredients: recipe.ingredients.filter((_, i) => i !== index),
});

/** Remove step at a given index. */
export const removeStep = (recipe: Recipe, index: number): Recipe => ({
  ...recipe,
  steps: recipe.steps.filter((_, i) => i !== index),
});

